// API base URL — set VITE_API_URL in .env to override (baked in at build time)
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';

// Origin of the StoryMotion server (without the /api suffix).
// Published and capability URLs come from the Service (PUBLIC_BASE_URL, spec 011);
// never build them from this.
const smBaseUrl = apiUrl.replace(/\/api$/, '');

export { apiUrl, smBaseUrl };
